import React from "react";
import PropTypes from "prop-types";
import { Card, ListGroup } from "react-bootstrap";

const TopReferrals = ({ title, topSuppliers }) => (
  <Card>
    <Card.Header className="border-bottom">
      <h6 className="m-0">{title}</h6>
      <div className="block-handle" />
    </Card.Header>

    <Card.Body className="p-0">
      <ListGroup className="list-group-small list-group-flush">
        {topSuppliers.map((item, idx) => (
          <ListGroup.Item key={idx} className="d-flex px-3">
            <span className="text-style">{item.title}</span>
            <span className="ms-auto text-style">{item.value}</span>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Card.Body>
  </Card>
);

TopReferrals.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string,
  /**
   * The referral data.
   */
  topSuppliers: PropTypes.array,
};

TopReferrals.defaultProps = {
  title: "Top 5 Suppliers",
  topSuppliers: [],
};

export default TopReferrals;
